export const audioExtensionsToMimeType = new Map([
    ['aac', 'audio/aac'],
    ['flac', 'audio/flac'],
    ['mp3', 'audio/mpeg'],
    ['ogg', 'audio/ogg'],
    ['wav', 'audio/wav'],
]);
export const imageExtensionsToMimeType = new Map([
    ['bmp', 'image/bmp'],
    ['gif', 'image/gif'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['png', 'image/png'],
    ['svg', 'image/svg+xml'],
    ['webp', 'image/webp'],
]);
export const pdfExtensionsToMimeType = new Map([
    ['pdf', 'application/pdf'],
]);
export const videoExtensionsToMimeType = new Map([
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['webm', 'video/webm'],
]);
export const allSupportedExtensions = new Map([
    ...audioExtensionsToMimeType,
    ...imageExtensionsToMimeType,
    ...pdfExtensionsToMimeType,
    ...videoExtensionsToMimeType,
]);
